// extracted by mini-css-extract-plugin
module.exports = {"moreIntegrations":"_0a6661","integration":"_9df111","link":"_57e219"};